// src/screens/tabs/Home/HomeScreen.tsx
import React, { useState, useEffect } from "react";
import { View, ScrollView, Text, Alert } from "react-native";

import { Restaurant } from "../components/shared/types/restaurant.types";
import LoadingSpinnerTrans from "../components/shared/LoadingSpinner";
import { menuScreenStyles } from "../components/shared/styles/styles";
import { LocBar } from "../components/layout/LocBar";
import { SearchBar } from "../components/shared/component/SearchBar";
import { FlickOColors } from "../components/shared/styles/color";
import { FilterDropdown } from "../components/shared/component/FilterDropdown";
import { QuickFilters } from "../components/shared/component/QuickFilters";
import { RestaurantCard } from "./RestaurantCard";
import { restaurantService } from "../services/restaurant.service";
import { registrationStyles } from "../components/shared/styles/registrationStyles";
import { DecodedToken } from "../types/token";
import { secureStoreService } from "../components/shared/services/secure-store.service";
import { Coordinates, DefaultLocation, UserCreDB } from "../types/user";
import { userService } from "../services/user.service";
import { defaultLocationService } from "../services/defaultLocation.service";
import { MenuFilterState } from "../components/shared/screens/menu/FilterTypes";
import { GridData } from "../components/shared/types/grid";

const HomeScreen = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [restaurants, setRestaurants] = useState<GridData[]>([]);
  const [filters, setFilters] = useState<MenuFilterState>({
    sortBy: "rating-high-low",
    rating: 4,
    cuisine: [],
  });
  const [user, setUser] = useState<UserCreDB | null>(null); // Add proper type instead of any
  const [defaultLocation, setDefaultLocation] =
    useState<DefaultLocation | null>(null);
  const [loading, setLoading] = useState(true);
  const [selectedTypes, setSelectedTypes] = useState<
    ("veg" | "egg" | "non-veg")[]
  >([]);

  const handleToggleType = (type: "veg" | "egg" | "non-veg") => {
    setSelectedTypes((prev) =>
      prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
    );
  };

  const getSetUser = async (): Promise<Coordinates | null> => {
    try {
      console.log("getSetUser called");
      const token: DecodedToken | null =
        await secureStoreService.getDecodedAccessToken();
      const userData: UserCreDB | null = await userService.getCachedUser(
        token?.restUserId as string
      );
      setUser(userData);

      // If user exists but has no location, fetch default location
      if (userData && !userData.location?.addresses?.length) {
        console.log("trying to get default location");
        const defaultLoc: DefaultLocation | null =
          await defaultLocationService.getSetDefaultLocation();
        console.log("defaultLoc: ", defaultLoc);
        if (defaultLoc) {
          setDefaultLocation(defaultLoc);
        }
        return defaultLoc?.coordinates as Coordinates;
      } else if (!userData?.location) {
        return null;
      }

      const currID = userData.location.currentId;
      const loc = userData.location?.addresses.find((map) => currID in map)?.[
        currID
      ].coordinates as Coordinates;
      return loc;
    } catch (error) {
      console.error("Error fetching user:", error);
    }
    return null;
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        console.log("loadData called");
        const loc: Coordinates | null = await getSetUser();
        console.log("loc: ", loc);
        if (!loc) {
          Alert.alert(
            "Error",
            "Unable to retrieve your location. Please ensure location services are enabled and try again."
          );
          return;
        }
        await loadRestaurants(loc);
      } catch (error) {
        console.log("error:", error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const loadRestaurants = async (loc: Coordinates) => {
    try {
      console.log("loadRestaurants called");
      const data: GridData[] = await restaurantService.getRestaurants(loc);
      setRestaurants(data);
    } catch (error) {
      console.error("Error loading restaurants:", error);
    }
  };

  if (loading) {
    return (
      <LoadingSpinnerTrans text="Finding the best restaurants for you..." />
    );
  }

  return (
    //.container homescreen in partner
    <View style={menuScreenStyles.container}>
      {/*.container menuscreen in parrter app */}
      <View style={menuScreenStyles.container}>
        <LocBar title="" user={user} defaultLocation={defaultLocation}></LocBar>
        <ScrollView>
          <SearchBar
            value={searchQuery}
            onChangeText={setSearchQuery}
            placeholder="Search restaurants"
            iconColor={FlickOColors.text.secondary}
          />

          <ScrollView
            horizontal
            showsHorizontalScrollIndicator={false}
            style={menuScreenStyles.filtersScrollView}
          >
            <FilterDropdown
              filters={filters}
              onApplyFilters={setFilters}
              onClearFilters={() => {}}
            />
            <QuickFilters
              selectedTypes={selectedTypes}
              onToggleType={handleToggleType}
              onMoreFilters={() => {}}
            />
          </ScrollView>

          <View style={registrationStyles.exploreSection}>
            <Text style={registrationStyles.exploreTitle}>
              Top {restaurants.length} restaurants to explore
            </Text>
            <Text style={registrationStyles.exploreSubtitle}>
              FEATURED RESTAURANTS
            </Text>
          </View>

          <View>
            {restaurants.map((restaurant: GridData) => (
              <RestaurantCard key={restaurant.id} restaurant={restaurant} />
            ))}
          </View>
        </ScrollView>
      </View>
    </View>
  );
};

export default HomeScreen;
